import {
  ContextStore,
  PageStore,
  AnalyticsStore
} from 'bernie-plugin-mobx';
import {
  Controller,
  codeSplit,
  FetchOptions,
  FetchPageOptions
} from 'bernie-core';
import { CarDetailStore, DetailCriteriaStore } from 'stores';
import { PageData } from 'bernie-http';
import { PageId, PageURL } from 'utils/page-identity';
import { Localization } from 'bernie-l10n';
import '../client/temp-common-imports';
import { AdvertisingStore } from 'bernie-plugin-ads-loader-script';

export class CarDetailController implements Controller {
  public bundles = [];
  public path = PageURL.CIS;
  public routeName = 'carDetail';
  public pageId = PageId.CIS;

  public component = codeSplit(() => import(/* webpackChunkName: 'car-detail-page' */ '../views/car-detail-page'));

  public exact = true;

  public async fetch(options: FetchOptions): Promise<any> {
    if (!options || !options.stores) {
      return Promise.reject('CarDetail.fetch received invalid FetchOptions');
    }
    const { stores, query, isServer } = options;

    const carDetailStore: CarDetailStore = stores.get<CarDetailStore>('carDetailStore');
    const detailCriteriaStore: DetailCriteriaStore = stores.get<DetailCriteriaStore>('detailCriteriaStore');
    const context: ContextStore = stores.get<ContextStore>('context');
    const page: PageStore = stores.get<PageStore>('page');
    const analytics = stores.get<AnalyticsStore>('analytics');
    const advertising: AdvertisingStore = stores.get<AdvertisingStore>('advertising');
    page.pageName = this.pageId.split(',')[0];
    advertising.trigger(page.pageName);
    const { detailOfferPiid, resolvedFromServer, clickedSearchOfferPiid, errorInFetchingResult, piidUpdated } = carDetailStore;
    const { detailQuery: prevQuery } = detailCriteriaStore;

    //Doing client side rendering right now until we figure out how to do loading skeleton view on page load
    if (isServer) {
      return Promise.resolve({});
    }

    // Do not call downstream if we are just going to and coming back from dialogs
    if (
      (!prevQuery['pwaDialog'] && query['pwaDialog']) ||
      (prevQuery['pwaDialog'] && !query['pwaDialog']) ||
      (!prevQuery['pwaDialogNested'] && query['pwaDialogNested']) ||
      (prevQuery['pwaDialogNested'] && !query['pwaDialogNested']) ||
      (!prevQuery['notificationCenterDeleteDialog'] && query['notificationCenterDeleteDialog']) ||
      (prevQuery['notificationCenterDeleteDialog'] && !query['notificationCenterDeleteDialog'])
    ) {
      detailCriteriaStore.setDetailQuery(query);

      return Promise.resolve({});
    }
    if (prevQuery['piid'] !== detailOfferPiid && !detailCriteriaStore.loadingCriteriaChange && !errorInFetchingResult && piidUpdated) {
      detailCriteriaStore.setDetailQuery(query);
      carDetailStore.piidUpdated = false;
      
      return Promise.resolve({});
    }

    if (clickedSearchOfferPiid && !detailCriteriaStore.loadingCriteriaChange && detailOfferPiid && resolvedFromServer && !errorInFetchingResult) {
      return Promise.resolve({});
    }

    detailCriteriaStore.setContext(context);
    detailCriteriaStore.setPage(page);
    detailCriteriaStore.setDetailQuery(query);

    const rcpRedirect = true;

    return Promise.resolve(carDetailStore.getCarDetail(detailCriteriaStore, context, this.pageId, isServer, analytics, rcpRedirect));
  }

  public fetchPageData(fetchPageOptions: FetchPageOptions): Promise<PageData> {
    const localizer = new Localization(fetchPageOptions.context.locale);
    const defaultPageTitle = localizer.formatText('page.title.detail.default');

    return Promise.resolve({ title : defaultPageTitle }) as Promise<PageData>;
  }
}
